import React from "react";
import { Helmet } from "react-helmet";
import MBAApplicationHeader from "./components/MBAApplicationHeader";
import SiteFooter from "../../components/layout/SiteFooter";

const MBAApplication = () => (
  <div className="bg-gray-50 min-h-screen">
    <Helmet>
      <title>
        Apply — Utiva MiniMBA | Business Leadership &amp; AI Transformation
      </title>
      <meta
        name="description"
        content="Apply for the Utiva MiniMBA programme. Complete your application form to secure your spot."
      />
      <meta
        property="og:title"
        content="Apply — Utiva MiniMBA | Business Leadership & AI Transformation"
      />
      <meta
        property="og:description"
        content="Apply for the Utiva MiniMBA programme. Complete your application form to secure your spot."
      />
      <meta property="og:url" content={window.location.href} />
      <meta property="og:type" content="website" />
    </Helmet>

    <MBAApplicationHeader currentStep={0} />

    <main className="container mx-auto px-4 py-10 ">
      <div className="bg-white rounded-2xl hire-card overflow-hidden">
        <iframe
          aria-label="Start The Application Into The Utiva miniMBA"
          frameBorder="0"
          src="https://forms.zohopublic.com/utiva/form/UTIVAMMBAAPPLICATION/formperma/P6-VYxxsUBNCsRWB_yaGwWrwhdXy80rFzxR4RzjneJ0"
          style={{ height: "800px", width: "100%", border: 0 }}
          title="Utiva MiniMBA Application Form"
          allowfullscreen=""
          aria-hidden="false"
          tabindex="0"
        />
      </div>
    </main>

    <SiteFooter />
  </div>
);

export default MBAApplication;
